import { IReferralState } from './interface/IReferralState'

export const initialState: IReferralState = {}
